const toggleHiddenContactItemContent = (source) => {
    source.addEventListener("click", (e) => {
        console.log('test')
        e.preventDefault()
        let targetValue = source.dataset.hiddenContentOnClick
        const additionalTextValue = source.dataset.hiddenContentAdditionalText
        const target = source.querySelector('[data-hidden-content-target]')
        target.innerHTML = targetValue
        source.removeAttribute('data-hidden-content-on-click')
        if(additionalTextValue) {
            const additionalElement = document.createElement('span')
            additionalElement.classList.add('additional-info')
            additionalElement.innerHTML = additionalTextValue
            source.removeAttribute('data-hidden-content-additional-text')

            target.appendChild(additionalElement)
        }
    }, {once : true})
}

const showHiddenContactItemInfo = document.querySelectorAll("[data-hidden-content-on-click]");
showHiddenContactItemInfo.forEach(toggleHiddenContactItemContent);
